import Vue from "vue";
import FormWrapper from "./form-wrapper";

document.addEventListener("DOMContentLoaded", () => {
  // Form
  const formMount = document.querySelector("collection-form");
  const isCollapsible = formMount.getAttribute("data-sub-page") !== "search";
  const dataFilteredTotal = parseInt(formMount.getAttribute("data-filtered-total"));
  const dataTotal = parseInt(formMount.getAttribute("data-total"));
  const parsedClassification = formMount.getAttribute("param-classification");
  const paramClassification = parsedClassification === '-1' ? 'any' : parsedClassification;
  const paramDateBegin = formMount.getAttribute("param-date-begin");
  const paramDateEnd = formMount.getAttribute("param-date-end");
  const paramIncludeUncataloguedWorks = formMount.getAttribute("param-include-uncatalogued-works") === "true";
  const paramOnView = formMount.getAttribute("param-on-view") === "true";
  const paramRecentAcquisitions = formMount.getAttribute("param-recent-acquisitions") === "true";
  const paramSearchTerm = formMount.getAttribute("param-search-term");
  const paramWithImages = formMount.getAttribute("param-with-images") === "true";

  // Filter/pagination
  const paginationMount = document.querySelector("[data-pagination-mount]");
  const dataFetchBaseURL = paginationMount.getAttribute("data-fetch-base-url");
  const dataLastPage = parseInt(paginationMount.getAttribute("data-last-page"));
  const dataShowMoreItemsButtonHTML = paginationMount.getAttribute('data-show-more-items-button-html');

  new Vue({
    el: formMount,
    components: {
      FormWrapper
    },
    data: {
      dataFilteredTotal: dataFilteredTotal,
      dataTotal: dataTotal,
      isCollapsible: isCollapsible,
      paramClassification: paramClassification,
      paramDateBegin: paramDateBegin,
      paramDateEnd: paramDateEnd,
      paramIncludeUncataloguedWorks: paramIncludeUncataloguedWorks,
      paramOnView: paramOnView,
      paramRecentAcquisitions: paramRecentAcquisitions,
      paramSearchTerm: paramSearchTerm,
      paramWithImages: paramWithImages,

      // Filter/pagination
      dataFetchBaseURL: dataFetchBaseURL,
      dataLastPage: dataLastPage,
      dataShowMoreItemsButtonHTML: dataShowMoreItemsButtonHTML,
    },
    template: `
      <FormWrapper
        :dataFilteredTotal=dataFilteredTotal
        :dataTotal=dataTotal
        :isCollapsible=isCollapsible
        :param-classification=paramClassification
        :param-date-begin=paramDateBegin
        :param-date-end=paramDateEnd
        :param-include-uncatalogued-works=paramIncludeUncataloguedWorks
        :param-on-view=paramOnView
        :param-recent-acquisitions=paramRecentAcquisitions
        :param-search-term=paramSearchTerm
        :param-with-images=paramWithImages

        :dataFetchBaseURL=dataFetchBaseURL
        :dataLastPage=dataLastPage
        :dataShowMoreItemsButtonHTML=dataShowMoreItemsButtonHTML
      />
    `,
  });
});
